import { AppBannerService } from "@modules/appBanner/services/appBannerService"
import { ArticleApi } from "@modules/article/gateway/articleApi"
import { ArticleApiGateway } from "@modules/article/gateway/articleApiGateway"
import { AuthService } from "@modules/auth/services/authService"
import { IAuthService } from "@modules/auth/services/authService.type"
import { UserProfileApi } from "@modules/auth/services/userProfileApi"
import { UserProfileApiGateway } from "@modules/auth/services/userProfileApi.gateway"
import { UserProfileService } from "@modules/auth/services/userProfileService"
import { BenchmarkApi } from "@modules/benchmark/api/benchmarkApi"
import { BenchmarkApiGateway } from "@modules/benchmark/api/benchmarkGateway"
import { BoxApi } from "@modules/box/services/boxApi"
import { BoxApiGateway } from "@modules/box/services/boxApi.gateway"
import { BoxService } from "@modules/box/services/boxService"
import { BoxB2BProgramApi } from "@modules/boxB2BProgram/services/boxB2BProgramApi"
import { BoxB2BProgramService } from "@modules/boxB2BProgram/services/boxB2BProgramService"
import { BoxLeadApi } from "@modules/boxLead/gateway/boxLeadApi"
import { BoxLeadApiGateway } from "@modules/boxLead/gateway/boxLeadApiGateway"
import { OfferApi } from "@modules/boxOffer/gateway/boxOfferApi"
import { BoxOfferApiGateway } from "@modules/boxOffer/gateway/boxOfferApi.gateway"
import { BoxPlanningApi } from "@modules/boxPlanning/services/boxPlanningApi"
import { BoxPlanningService } from "@modules/boxPlanning/services/boxPlanningService"
import { BoxProgrammationApi } from "@modules/boxProgrammation/services/boxProgrammationApi"
import { BoxProgrammationService } from "@modules/boxProgrammation/services/boxProgrammationService"
import { BoxProgrammationTemplatePopUpService } from "@modules/boxProgrammation/services/boxProgrammationTemplatePopUpService"
import { BoxPurchasesApi } from "@modules/boxPurchases/gateway/boxPurchasesApi"
import { BoxPurchasesApiGateway } from "@modules/boxPurchases/gateway/boxPurchasesApiGateway"
import { BoxSlotApi } from "@modules/boxSlot/services/boxSlotApi"
import { BoxSlotService } from "@modules/boxSlot/services/boxSlotService"
import { BoxSlotTemplateApi } from "@modules/boxSlotTemplate/services/boxSlotTemplateApi"
import { BoxSlotTemplateService } from "@modules/boxSlotTemplate/services/boxSlotTemplateService"
import { BoxStaffApi } from "@modules/boxStaff/gateway/boxStaffApi"
import { BoxStaffApiGateway } from "@modules/boxStaff/gateway/boxStaffApiGateway"
import { BoxSubscriptionApi } from "@modules/boxSubscription/gateway/boxSubscriptionApi"
import { BoxSubscriptionApiGateway } from "@modules/boxSubscription/gateway/boxSubscriptionApiGateway"
import { ChatApi } from "@modules/chat/services/chatApi"
import { ChatService } from "@modules/chat/services/chatService"
import { MediaApi } from "@modules/common/media/api/mediaApi"
import { MediaApiGateway } from "@modules/common/media/api/mediaApiGateway"
import { Config } from "@modules/config"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { ApiService } from "@modules/core/services/apiService"
import { ConfigService } from "@modules/core/services/configService"
import { CurrentSpaceManager } from "@modules/core/services/currentSpaceManager"
import { CurrentSpaceManagerType } from "@modules/core/services/currentSpaceManager.type"
import { DateService } from "@modules/core/services/dateService"
import { WebServiceManager } from "@modules/core/services/webServiceManager"
import { CrossfitEventApi } from "@modules/crossfitEvent/api/crossfitEventApi"
import { CrossfitEventApiGateway } from "@modules/crossfitEvent/api/crossfitEventGateway"
import { ExploreApi } from "@modules/explore/gateway/exploreApi"
import { FeatureToggleService } from "@modules/featureToggle/services/featureToggleService"
import { BoxFinanceApi } from "@modules/finances/gateway/boxFinanceApi"
import { BoxFinanceApiGateway } from "@modules/finances/gateway/boxFinanceApiGateway"
import { UserFinanceApi } from "@modules/finances/gateway/userFinanceApi"
import { UserFinanceApiGateway } from "@modules/finances/gateway/userFinanceApiGateway"
import { PayoutApi } from "@modules/financesPayout/gateway/payoutApi"
import { PayoutApiGateway } from "@modules/financesPayout/gateway/payoutApiGateway"
import { HomeApi } from "@modules/home/gateway/homeApi"
import { HomeApiGateway } from "@modules/home/gateway/homeApiGateway"
import { LanguageService } from "@modules/language/services/languageService"
import { MemberApi } from "@modules/members/gateway/memberApi"
import { MemberApiGateway } from "@modules/members/gateway/memberApiGateway"
import { ObjectivesApi } from "@modules/objectives/services/objectivesApi"
import { ObjectivesService } from "@modules/objectives/services/objectivesService"
import { PaymentApi } from "@modules/payment/services/paymentApi"
import { PaymentService } from "@modules/payment/services/paymentService"
import { PublicProfileApi } from "@modules/profile/publicProfile/services/publicProfileApi"
import { PublicProfileApiGateway } from "@modules/profile/publicProfile/services/publicProfileApi.gateway"
import { PublicProfileService } from "@modules/profile/publicProfile/services/publicProfileService"
import { BrowserProfileService } from "@modules/profile/services/browserProfileService"
import { ProgramBundleApi } from "@modules/programBundle/api/programBundleApi"
import { ProgramBundleApiGateway } from "@modules/programBundle/api/programBundleApiGateway"
import { ProgramBundleSubscriberApi } from "@modules/programBundle/programBundleSubscribers/gateway/programBundleSubscriberApi"
import { ProgramBundleSubscriberApiGateway } from "@modules/programBundle/programBundleSubscribers/gateway/programBundleSubscriberApiGateway"
import { ProgramInfiniteSessionApi } from "@modules/programSession/services/programInfiniteSessionApi"
import { ProgramOnOffSessionApi } from "@modules/programSession/services/programOnOffSessionApi"
import { ProgramSessionService } from "@modules/programSession/services/programSessionService"
import { ProgramSubscriberApi } from "@modules/programs/programSubscriber/gateway/programSubscriberApi"
import { ProgramSubscriberApiGateway } from "@modules/programs/programSubscriber/gateway/programSubscriberApiGateway"
import { ProgramApi } from "@modules/programs/services/programApi"
import { ProgramApiGateway } from "@modules/programs/services/programApi.gateway"
import { ProgramInfiniteApi } from "@modules/programs/services/programInfiniteApi"
import { ProgramInfiniteService } from "@modules/programs/services/programInfiniteService"
import { ProgramOnOffApi } from "@modules/programs/services/programOnOffApi"
import { ProgramOnOffService } from "@modules/programs/services/programOnOffService"
import { ProgramService } from "@modules/programs/services/programService"
import { BoxPromoCodeApi } from "@modules/promoCode/services/boxPromoCodeApi"
import { BoxPromoCodeApiGateway } from "@modules/promoCode/services/boxPromoCodeApi.gateway"
import { BoxPromoCodeService } from "@modules/promoCode/services/boxPromoCodeService"
import { PromoCodeApi } from "@modules/promoCode/services/promoCodeApi"
import { PromoCodeApiGateway } from "@modules/promoCode/services/promoCodeApi.gateway"
import { PromoCodeService } from "@modules/promoCode/services/promoCodeService"
import { RemoteConfigService } from "@modules/remoteConfig/services/remoteConfigService"
import { ScoreboardApi } from "@modules/scoreboard/services/scoreboardApi"
import { ScoreboardService } from "@modules/scoreboard/services/scoreboardService"
import { AssetApi } from "@modules/services/assetApi"
import { AssetService } from "@modules/services/assetService"
import { ExerciseApi } from "@modules/sessionBlock/exercises/services/exerciseApi"
import { ExerciseService } from "@modules/sessionBlock/exercises/services/exerciseService"
import { LocalStorageService } from "@modules/storage/services/localStorageService"
import { WebStorage } from "@modules/storage/storage"
import { PlanningService } from "@modules/training/services/planningService"
import { TrainingApi } from "@modules/training/services/trainingApi"
import { TrainingApiGateway } from "@modules/training/services/trainingApi.gateway"
import { QueryClient } from "@tanstack/react-query"

export const getAllServices = ({
  customAuthService,
  customCurrentSpaceManager,
  customApiClient,
  customUserProfileApi,
  customBoxApi,
  customBoxProgrammationApi,
  customChatApi,
  customMemberApi,
  customBoxOfferApi,
  customAssetApi,
  customProgramApi,
  customProgramBundleApi,
  customProgramBundleSubscriberApi,
  customProgramInfiniteApi,
  customProgramOnOffApi,
  customProgramSubscriberApi,
  customProgramInfiniteSessionApi,
  customProgramOnOffSessionApi,
  customExploreApi,
  customArticleGateway,
  customScoreboardApi,
  customBenchmarkApi,
  customObjectivesApi,
  customBoxPlanningApi,
  customBoxSlotTemplateApi,
  customBoxB2BProgramApi,
  customBoxSlotApi,
  customPaymentApi,
  customBoxFinanceApi,
  customUserFinanceApi,
  customBoxStaffApi,
  customTrainingApi,
  customExerciseApi,
  customPromoCodeApi,
  customBoxPromoCodeApi,
  customCrossfitEventApi,
  customHomeApi,
  customMediaApi,
  customBoxSubscriptionApi,
  customQueryClient,
  customBoxPurchasesApi,
  customPayoutApi,
  customBoxLeadApi,
  customPublicProfileApi,
}: {
  customAuthService?: IAuthService
  customCurrentSpaceManager?: CurrentSpaceManagerType
  customApiClient?: ApiClient
  customPublicProfileApi?: PublicProfileApiGateway
  customUserProfileApi?: UserProfileApiGateway
  customBoxApi?: BoxApiGateway
  customBoxProgrammationApi?: BoxProgrammationApi
  customChatApi?: ChatApi
  customBoxOfferApi?: BoxOfferApiGateway
  customMemberApi?: MemberApiGateway
  customAssetApi?: AssetApi
  customProgramApi?: ProgramApiGateway
  customProgramInfiniteApi?: ProgramInfiniteApi
  customProgramOnOffApi?: ProgramOnOffApi
  customProgramBundleApi?: ProgramBundleApiGateway
  customProgramBundleSubscriberApi?: ProgramBundleSubscriberApiGateway
  customProgramSubscriberApi?: ProgramSubscriberApiGateway
  customProgramInfiniteSessionApi?: ProgramInfiniteSessionApi
  customProgramOnOffSessionApi?: ProgramOnOffSessionApi
  customExploreApi?: ExploreApi
  customArticleGateway?: ArticleApiGateway
  customScoreboardApi?: ScoreboardApi
  customBenchmarkApi?: BenchmarkApiGateway
  customObjectivesApi?: ObjectivesApi
  customBoxPlanningApi?: BoxPlanningApi
  customBoxSlotTemplateApi?: BoxSlotTemplateApi
  customBoxB2BProgramApi?: BoxB2BProgramApi
  customBoxSlotApi?: BoxSlotApi
  customPaymentApi?: PaymentApi
  customBoxFinanceApi?: BoxFinanceApiGateway
  customUserFinanceApi?: UserFinanceApiGateway
  customTrainingApi?: TrainingApiGateway
  customExerciseApi?: ExerciseApi
  customPromoCodeApi?: PromoCodeApiGateway
  customBoxPromoCodeApi?: BoxPromoCodeApiGateway
  customCrossfitEventApi?: CrossfitEventApiGateway
  customHomeApi?: HomeApiGateway
  customMediaApi?: MediaApiGateway
  customQueryClient?: QueryClient
  customBoxPurchasesApi?: BoxPurchasesApiGateway
  customBoxSubscriptionApi?: BoxSubscriptionApiGateway
  customBoxStaffApi?: BoxStaffApiGateway
  customPayoutApi?: PayoutApiGateway
  customBoxLeadApi?: BoxLeadApiGateway
} = {}) => {
  ConfigService.setConfig(Config)
  ConfigService.setDevMode(import.meta.env.DEV)

  /**
   * API
   */
  const apiClient = customApiClient || new ApiClient()
  const publicUserApi = customPublicProfileApi || new PublicProfileApi(apiClient)
  const userProfileApi = customUserProfileApi || new UserProfileApi(apiClient)
  const boxApi = customBoxApi || new BoxApi(apiClient)
  const boxProgrammationApi = customBoxProgrammationApi || new BoxProgrammationApi(apiClient)
  const chatApi = customChatApi || new ChatApi(apiClient)
  const memberApi = customMemberApi || new MemberApi(apiClient)
  const boxOfferApi = customBoxOfferApi || new OfferApi(apiClient)
  const assetApi = customAssetApi || new AssetApi(apiClient)
  const programApi = customProgramApi || new ProgramApi(apiClient)
  const programInfiniteApi = customProgramInfiniteApi || new ProgramInfiniteApi(apiClient)
  const programOnOffApi = customProgramOnOffApi || new ProgramOnOffApi(apiClient)
  const programBundleApi = customProgramBundleApi || new ProgramBundleApi(apiClient)
  const programSubscriberApi = customProgramSubscriberApi || new ProgramSubscriberApi(apiClient)
  const programBundleSubscriberApi = customProgramBundleSubscriberApi || new ProgramBundleSubscriberApi(apiClient)
  const programInfiniteSessionApi = customProgramInfiniteSessionApi || new ProgramInfiniteSessionApi(apiClient)
  const programOnOffSessionApi = customProgramOnOffSessionApi || new ProgramOnOffSessionApi(apiClient)
  const exploreApi = customExploreApi ?? new ExploreApi(apiClient)
  const articleApi = customArticleGateway ?? new ArticleApi()
  const scoreboardApi = customScoreboardApi ?? new ScoreboardApi(apiClient)
  const benchmarkApi = customBenchmarkApi || new BenchmarkApi(apiClient)
  const objectivesApi = customObjectivesApi || new ObjectivesApi(apiClient)
  const boxPlanningApi = customBoxPlanningApi || new BoxPlanningApi(apiClient)
  const boxSlotTemplateApi = customBoxSlotTemplateApi || new BoxSlotTemplateApi(apiClient)
  const boxB2BProgramApi = customBoxB2BProgramApi || new BoxB2BProgramApi(apiClient)
  const boxSlotApi = customBoxSlotApi || new BoxSlotApi(apiClient)
  const paymentApi = customPaymentApi || new PaymentApi(apiClient)
  const boxFinanceApi = customBoxFinanceApi || new BoxFinanceApi(apiClient)
  const userFinanceApi = customUserFinanceApi || new UserFinanceApi(apiClient)
  const boxStaffApi = customBoxStaffApi || new BoxStaffApi(apiClient)
  const trainingApi = customTrainingApi || new TrainingApi(apiClient)
  const exerciseApi = customExerciseApi || new ExerciseApi(apiClient)
  const promoCodeApi = customPromoCodeApi || new PromoCodeApi(apiClient)
  const boxPromoCodeApi = customBoxPromoCodeApi || new BoxPromoCodeApi(apiClient)
  const crossfitEventApi = customCrossfitEventApi || new CrossfitEventApi(apiClient)
  const homeApi = customHomeApi || new HomeApi()
  const mediaApi = customMediaApi || new MediaApi(apiClient)
  const boxSubscriptionApi = customBoxSubscriptionApi || new BoxSubscriptionApi(apiClient)
  const boxPurchasesApi = customBoxPurchasesApi || new BoxPurchasesApi(apiClient)
  const payoutApi = customPayoutApi || new PayoutApi(apiClient)
  const boxLeadApi = customBoxLeadApi || new BoxLeadApi(apiClient)
  /**
   * SERVICES
   */
  const queryClient = customQueryClient ?? new QueryClient()

  const localStorageService = new LocalStorageService(new WebStorage())
  const currentSpaceManager =
    customCurrentSpaceManager || new CurrentSpaceManager(localStorageService, apiClient, queryClient)
  const serviceManager = new WebServiceManager(ConfigService.devMode, currentSpaceManager)
  serviceManager.setActiveInstance(serviceManager)

  serviceManager.register(localStorageService)
  serviceManager.register(currentSpaceManager)
  const featureToggleService = serviceManager.register(new FeatureToggleService(localStorageService))
  const authService = serviceManager.register(customAuthService || new AuthService())
  const languageService = serviceManager.register(
    new LanguageService(localStorageService, apiClient, featureToggleService),
  )
  const browserProfileService = serviceManager.register(
    new BrowserProfileService(currentSpaceManager, localStorageService),
  )
  const userProfileService = serviceManager.register(
    new UserProfileService(authService, userProfileApi, localStorageService, serviceManager, queryClient),
  )
  const apiService = serviceManager.register(new ApiService(apiClient, userProfileService, authService))
  const boxService = serviceManager.register(new BoxService(boxApi, currentSpaceManager, queryClient))
  const paymentService = serviceManager.register(new PaymentService(paymentApi))
  const planningService = serviceManager.register(
    new PlanningService(
      programApi,
      programInfiniteApi,
      programOnOffApi,
      programInfiniteSessionApi,
      programOnOffSessionApi,
    ),
  )
  const programInfiniteService = serviceManager.register(
    new ProgramInfiniteService(programInfiniteApi, planningService, programApi),
  )
  const programOnOffService = serviceManager.register(
    new ProgramOnOffService(programOnOffApi, planningService, programApi),
  )
  const programService = serviceManager.register(
    new ProgramService(programApi, programInfiniteService, programOnOffService, planningService, paymentService),
  )
  const programSessionService = serviceManager.register(
    new ProgramSessionService(programInfiniteSessionApi, programOnOffSessionApi, queryClient),
  )
  const promoCodeService = serviceManager.register(new PromoCodeService(promoCodeApi))
  const boxPromoCodeService = serviceManager.register(new BoxPromoCodeService(boxPromoCodeApi))
  const objectivesService = serviceManager.register(new ObjectivesService(objectivesApi))
  const chatService = serviceManager.register(new ChatService(userProfileService, chatApi))
  const dateService = serviceManager.register(new DateService(languageService, featureToggleService))
  const boxPlanningService = serviceManager.register(new BoxPlanningService(boxPlanningApi))
  const boxProgrammationService = serviceManager.register(
    new BoxProgrammationService(boxProgrammationApi, localStorageService, queryClient),
  )
  const boxSlotService = serviceManager.register(new BoxSlotService(boxSlotApi))
  const boxSlotTemplateService = serviceManager.register(new BoxSlotTemplateService(boxSlotTemplateApi, boxSlotService))
  const boxB2BProgramService = serviceManager.register(new BoxB2BProgramService(boxB2BProgramApi))

  const remoteConfigService = serviceManager.register(new RemoteConfigService())
  const appBannerService = serviceManager.register(new AppBannerService(localStorageService))
  const boxProgrammationTemplatePopUpService = serviceManager.register(
    new BoxProgrammationTemplatePopUpService(localStorageService),
  )
  const sessionService = serviceManager.register(new ExerciseService(exerciseApi))
  const publicProfileService = serviceManager.register(new PublicProfileService(publicUserApi))
  const scoreboardService = serviceManager.register(new ScoreboardService(scoreboardApi))
  // Outside service manager
  const assetService = new AssetService(assetApi)

  const allServices = {
    serviceManager,
    apiService,
    appBannerService,
    boxProgrammationTemplatePopUpService,
    assetService,
    authService,
    boxPlanningService,
    boxProgrammationService,
    boxService,
    boxSlotService,
    boxSlotTemplateService,
    boxB2BProgramService,
    chatService,
    currentSpaceManager,
    dateService,
    featureToggleService,
    languageService,
    localStorageService,
    paymentService,
    planningService,
    browserProfileService,
    exploreApi,
    articleApi,
    trainingApi,
    scoreboardService,
    programService,
    programInfiniteApi,
    programOnOffApi,
    programSubscriberApi,
    programBundleSubscriberApi,
    programInfiniteService,
    programOnOffService,
    programBundleApi,
    benchmarkApi,
    objectivesService,
    programSessionService,
    programInfiniteSessionApi,
    programOnOffSessionApi,
    promoCodeService,
    boxPromoCodeService,
    sessionService,
    remoteConfigService,
    userProfileService,
    publicProfileService,
    crossfitEventApi,
    homeApi,
    mediaApi,
    boxSubscriptionApi,
    boxPurchasesApi,
    memberApi,
    boxStaffApi,
    boxApi,
    payoutApi,
    boxOfferApi,
    boxFinanceApi,
    userFinanceApi,
    boxLeadApi,
    publicUserApi,
  } as const

  return allServices
}
